<ion-app>
  @if(!isProduction){
  <div class="beta-lable">{{ "BETA" | translate }}</div>
  }
  <ion-router-outlet [swipeGesture]="false"></ion-router-outlet>
</ion-app>